import type { IOrgInvitationRepository } from "@/application/ports/repositories";
import type {
  OrganizationInvitation,
  CreateInvitationRequest,
  CreateInvitationResponse,
  VerifyInvitationRequest,
  VerifyInvitationResponse,
  CompleteInvitationRequest,
  CompleteInvitationResponse,
} from "@/domain/invitation";
import { apiClient } from "../client";

export class OrgInvitationRepository implements IOrgInvitationRepository {
  async getInvitations(): Promise<OrganizationInvitation[]> {
    const response = await apiClient.get<OrganizationInvitation[]>("/invitations");
    return response.data;
  }
  async createInvitation(
    invitationData: CreateInvitationRequest,
  ): Promise<CreateInvitationResponse> {
    const response = await apiClient.post<CreateInvitationResponse>("/invitations", invitationData);
    return response.data;
  }
  async resendInvitation(invitationUuid: string): Promise<void> {
    await apiClient.post(`/invitations/${invitationUuid}/resend`);
  }
  async cancelInvitation(invitationUuid: string): Promise<void> {
    await apiClient.delete(`/invitations/${invitationUuid}`);
  }
  async verifyInvitation(request: VerifyInvitationRequest): Promise<VerifyInvitationResponse> {
    const url = `/invitations/verify?token=${request.token}&invitation_uuid=${request.invitation_uuid}`;
    const response = await apiClient.get<VerifyInvitationResponse>(url);
    return response.data;
  }
  async completeInvitation(
    invitationUuid: string,
    token: string,
    data: CompleteInvitationRequest,
  ): Promise<CompleteInvitationResponse> {
    const url = `/invitations/${invitationUuid}/complete?token=${token}`;
    const response = await apiClient.post<CompleteInvitationResponse>(url, data);
    return response.data;
  }
}
